import { SVGProps } from 'react';

const KeyboardInput = ({
  width = 29,
  height = 37,
  fill = '#FF8200',
  ...otherProps
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29 37"
    {...otherProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 0C2.23858 0 0 2.23858 0 5V32C0 34.7614 2.23858 37 5 37H24C26.7614 37 29 34.7614 29 32V5C29 2.23858 26.7614 0 24 0H5ZM5.2 2C3.43269 2 2 3.43269 2 5.2V31.8C2 33.5673 3.43269 35 5.2 35H23.8C25.5673 35 27 33.5673 27 31.8V5.2C27 3.43269 25.5673 2 23.8 2H5.2Z"
      fill="#2A2A2A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 31C8.88071 31 10 29.8807 10 28.5C10 27.1193 8.88071 26 7.5 26C6.11929 26 5 27.1193 5 28.5C5 29.8807 6.11929 31 7.5 31ZM7.50001 29.5719C8.09174 29.5719 8.57144 29.0922 8.57144 28.5005C8.57144 27.9087 8.09174 27.429 7.50001 27.429C6.90827 27.429 6.42858 27.9087 6.42858 28.5005C6.42858 29.0922 6.90827 29.5719 7.50001 29.5719Z"
      fill="#FFC6C9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5 31C15.8807 31 17 29.8807 17 28.5C17 27.1193 15.8807 26 14.5 26C13.1193 26 12 27.1193 12 28.5C12 29.8807 13.1193 31 14.5 31ZM14.5 29.5719C15.0917 29.5719 15.5714 29.0922 15.5714 28.5005C15.5714 27.9087 15.0917 27.429 14.5 27.429C13.9083 27.429 13.4286 27.9087 13.4286 28.5005C13.4286 29.0922 13.9083 29.5719 14.5 29.5719Z"
      fill="#FFC6C9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 24C12.3807 24 13.5 22.8807 13.5 21.5C13.5 20.1193 12.3807 19 11 19C9.61929 19 8.5 20.1193 8.5 21.5C8.5 22.8807 9.61929 24 11 24ZM11 22.5725C11.5918 22.5725 12.0714 22.0928 12.0714 21.5011C12.0714 20.9094 11.5918 20.4297 11 20.4297C10.4083 20.4297 9.92859 20.9094 9.92859 21.5011C9.92859 22.0928 10.4083 22.5725 11 22.5725Z"
      fill="#FFC6C9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 24C19.3807 24 20.5 22.8807 20.5 21.5C20.5 20.1193 19.3807 19 18 19C16.6193 19 15.5 20.1193 15.5 21.5C15.5 22.8807 16.6193 24 18 24ZM18 22.5725C18.5918 22.5725 19.0714 22.0928 19.0714 21.5011C19.0714 20.9094 18.5918 20.4297 18 20.4297C17.4083 20.4297 16.9286 20.9094 16.9286 21.5011C16.9286 22.0928 17.4083 22.5725 18 22.5725Z"
      fill="#FFC6C9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5 31C22.8807 31 24 29.8807 24 28.5C24 27.1193 22.8807 26 21.5 26C20.1193 26 19 27.1193 19 28.5C19 29.8807 20.1193 31 21.5 31ZM21.5 29.5719C22.0917 29.5719 22.5714 29.0922 22.5714 28.5005C22.5714 27.9087 22.0917 27.429 21.5 27.429C20.9083 27.429 20.4286 27.9087 20.4286 28.5005C20.4286 29.0922 20.9083 29.5719 21.5 29.5719Z"
      fill="#FFC6C9"
    />
    <path
      d="M11.9241 14.9999H17.7081V13.4879H13.8561V11.3519H16.7841V9.93592H13.8561V7.93192H17.5161V6.41992H11.9241V14.9999Z"
      fill={fill}
    />
  </svg>
);

export default KeyboardInput;
